<div [ngClass]="{'selected-record': rcRecordItem.isSelectedInTable, 'field-dirty': rcRecordItem.changedCols.indexOf(column.prop) > -1, 'error-cell': isError}">
	<ng-container *ngIf="!domain||domain.type!=='list'">
		<input *ngIf="inputType!=='number'"
			name="{{column.prop}}"
			pattern="{{domain?.pattern || null}}"
			appValidateRange="{{domain?.range || null}}"
			[(ngModel)]="rcRecordItem.props[column.prop]" 
			(ngModelChange)="onEdit()">
		<input *ngIf="inputType==='number'"
			name="{{column.prop}}"
			type="number"
			pattern="{{domain?.pattern || null}}"
			appValidateRange="{{domain?.range || null}}"
			[(ngModel)]="rcRecordItem.props[column.prop]" 
			(ngModelChange)="onEdit()">
	</ng-container>

	<select *ngIf="domain&&domain.type==='list'" 
		name="{{column.prop}}" 
		[ngClass]="{'invalid-select': rcRecordItem.props[column.prop] && domain.list.indexOf(rcRecordItem.props[column.prop]) < 0}"
		[(ngModel)]="rcRecordItem.props[column.prop]" 
		(ngModelChange)="onEdit()">
		<option *ngFor="let val of domain.list">{{val}}</option>
		<option [ngValue]="null">Null</option>
	</select>
</div>